
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M716.895232 245.76c34.133333-20.48 44.373333-61.44 23.893333-92.16S682.761899 109.226667 648.628565 126.293333c-34.133333 20.48-44.373333 61.44-23.893333 92.16 3.413333 13.653333 13.653333 20.48 23.893333 27.306667m0 0c-61.44 17.066667-102.4 71.68-102.4 136.533333v27.306667H256.095232C116.148565 409.6 0.095232 525.653333 0.095232 665.6c-3.413333 126.293333 85.333333 232.106667 208.213333 256-3.413333-3.413333-3.413333-6.826667-3.413333-10.24V887.466667c0-75.093333 61.44-136.533333 136.533333-136.533334-37.546667 0-68.266667-30.72-68.266666-68.266666s30.72-68.266667 68.266666-68.266667 68.266667 30.72 68.266667 68.266667-30.72 68.266667-68.266667 68.266666c75.093333 0 136.533333 61.44 136.533334 136.533334v20.48c0 6.826667-6.826667 13.653333-13.653334 13.653333h98.986667c-6.826667 0-13.653333-6.826667-13.653333-13.653333V887.466667c0-75.093333 61.44-136.533333 136.533333-136.533334-37.546667 0-68.266667-30.72-68.266667-68.266666s30.72-68.266667 68.266667-68.266667 68.266667 30.72 68.266667 68.266667-30.72 68.266667-68.266667 68.266666c75.093333 0 136.533333 61.44 136.533333 136.533334v37.546666c0 3.413333 0 6.826667-3.413333 10.24 119.466667-23.893333 208.213333-133.12 204.8-256 0-119.466667-85.333333-225.28-204.8-249.173333v-51.2c0-61.44-40.96-116.053333-102.4-133.12",
        "fill": "#47A2FF"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M409.695232 204.8H307.295232V139.946667c0-10.24-3.413333-20.48-10.24-27.306667-13.653333-13.653333-34.133333-17.066667-47.786667-3.413333l-3.413333 3.413333-98.986667 98.986667c-13.653333 13.653333-13.653333 37.546667 0 51.2l98.986667 98.986666c10.24 13.653333 34.133333 17.066667 47.786667 6.826667 10.24-6.826667 13.653333-17.066667 13.653333-27.306667V273.066667h102.4c20.48 0 34.133333-13.653333 34.133333-34.133334s-13.653333-34.133333-34.133333-34.133333z",
        "fill": "#ED7C66"
      }
    }
  ]
})
    }
  